import {InputGroupContainer} from '@app/lui2/InputGroup';
import styled, {css} from 'styled-components';

import Label from '../Label';
import {colorVar} from '../Theme/colors';

interface Props {
  warning?: boolean;
  error?: boolean;
  disabled?: boolean;
  size?: Size;
  minWidth?: string;
}

type Size = 'small' | 'compact' | 'default' | 'big' | 'huge';

const SIZE_TO_INPUT_HEIGHT = {
  small: '1.5rem',
  default: 'var(--input-default-size, 2.5rem)',
  compact: '2rem',
  big: '3.125rem',
  huge: '5.25rem',
};

const InputContainer = styled(Label)<Props>`
  position: relative;
  display: block;
  min-width: ${({minWidth}) => minWidth || '9ch'};
  flex-grow: 1;

  --icon-default-size: 1.25rem;

  --input-base-border-color: ${colorVar('outline')};
  --input-interaction-border-hover-color: ${colorVar('onSurface')};
  --input-interaction-border-focus-color: ${colorVar('primary')};
  --input-label-text-color: ${colorVar('onSurfaceVariant')};
  --input-supporting-text-color: ${colorVar('onSurfaceVariant')};
  --input-hover-label-text-color: ${colorVar('onSurface')};

  ${InputGroupContainer} & {
    width: unset;
    flex-grow: 1;
  }

  ${({size}) =>
    size &&
    css`
      height: ${SIZE_TO_INPUT_HEIGHT[size]};
    `}

  ${({warning}) =>
    warning &&
    css`
      --input-base-border-color: ${colorVar('warn')};
      --input-interaction-border-hover-color: ${colorVar('onWarnContainer')};
      --input-interaction-border-focus-color: ${colorVar('warn')};
      /* --input-label-text-color: ${colorVar('warn')}; */
      --input-supporting-text-color: ${colorVar('warn')};
      --input-hover-label-text-color: ${colorVar('onWarnContainer')};
    `}

  ${({error}) =>
    error &&
    css`
      --input-base-border-color: ${colorVar('error')};
      --input-interaction-border-hover-color: ${colorVar('onErrorContainer')};
      --input-interaction-border-focus-color: ${colorVar('error')};
      /* --input-label-text-color: ${colorVar('error')}; */
      --input-supporting-text-color: ${colorVar('error')};
      --input-hover-label-text-color: ${colorVar('onErrorContainer')};
    `}

  ${({disabled}) =>
    disabled &&
    css`
      opacity: 0.38;
      user-select: none;
      pointer-events: none;
    `}
`;

export default InputContainer;
